import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreCollection } from '../models';

export function useCollections() {
  const [collections, setCollections] = useState<StoreCollection[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getCollections()
      .then((data) => {
        if (active) setCollections(data);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar coleções'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { collections, isLoading, error, isEmpty: collections.length === 0 };
}
